import { Helmet } from "react-helmet";
import Navbar from "../../../../components/Navbar/Navbar";
import WhatsAppWidget from "../../../../components/Navbar/Whatsapp";
import Banner from "../../../../components/body/projectPageComponents/Banner";
import Overview from "../../../../components/body/projectPageComponents/Overview";
import Pricing from "../../../../components/body/projectPageComponents/Pricing";
import Gallery from "../../../../components/body/projectPageComponents/Gallery";
import Location from "../../../../components/body/projectPageComponents/Location";
import Highlights from "../../../../components/body/projectPageComponents/Highlights";
import SiteVisitBanner from "../../../../components/body/projectPageComponents/SiteVisitBanner";
import FloorPlans from "../../../../components/body/projectPageComponents/FloorPlans";
import Amenities from "../../../../components/body/projectPageComponents/Amenities";
import Faq from "../../../../components/body/projectPageComponents/Faq";
import SimilarProject from "../../../../components/body/projectPageComponents/SimilarProject";

import { projectsSobha } from "../../../../data/projects/sobha/data";
import { projectstarc } from "../../../../data/projects/Tarc/data";

export const TarcIshva = () => {
  const {
    tarcishva: {
      form_data,
      whatsapp,
      bannerdata,
      overview,
      sitevisit,
      pricing,
      floor_plan,
      highlights,
      location,
      gallery,
      faq,
      similar
    }
  } = projectstarc;

  return (
    <>
      <Helmet>
        <title>TARC Ishva, Sector 63A, Gurgaon | Luxury Residences with Modern Amenities</title>

        <meta
          name="description"
          content="Discover TARC Ishva in Sector 63A, Gurgaon – a premium residential project offering luxurious apartments with world-class amenities, excellent connectivity, and a serene lifestyle. Book your dream home today!"
        />

        <meta
          name="keywords"
          content="TARC Ishva Sector 63A, TARC Ishva Gurgaon, luxury apartments in Gurgaon, TARC Ishva price, TARC Ishva floor plan, TARC Ishva location, TARC Ishva amenities, premium residences Gurgaon, upscale living Gurgaon, luxury homes Gurgaon"
        />

        <link
          rel="canonical"
          href="https://propertystation.in/tarc-ishva-sector-63a-gurugram"
        />

        <meta
          name="robots"
          content="index, follow"
        />

      </Helmet>

      <WhatsAppWidget whatsappdata={whatsapp} />
      <Navbar />

      <div className="mt-20">
        <Banner
          bannerDesktopImage={bannerdata.bannerDesktopImage}
          bannerMobileImage={bannerdata.bannerMobileImage}
          data={bannerdata.data}
          formData={form_data}
        />
        <Overview overviewData={overview} stripdata={overview.stripdata} />
        <SiteVisitBanner image={sitevisit.image} formData={form_data} />
        <Pricing pricingData={pricing} formData={form_data} />
        <FloorPlans floorPlans={floor_plan} formData={form_data} />
        <Highlights hightlightData={highlights} formData={form_data} />
        <Amenities />
        <Location location={location} />
        <Gallery galleryData={gallery} />
        <Faq faqdata={faq} />
        <SimilarProject Similarprojects={similar} />
      </div>
    </>
  );
};
